import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';
import { getFormatterForKodif, getNumberFormatter } from "../grid/ColumnHelpers";
import { dzeramaUdensSatecesBaseinsVisparigaInfoActions } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import { getKlasifikatorsFieldCfg } from '../forms/FormHelpers';
import Loading from '../Loading';
import NavGeometrijaBridinajums from './NavGeometrijaBridinajums';
import Form from '../forms/Form';
import BootstrapTable from 'react-bootstrap-table-next';

export const zemesLietojumsColumns = [
  { dataField: 'zemes_lietosanas_veids', text: 'Zemes lietošanas veids' },
  {
    dataField: 'izplatiba_procenti',
    text: 'Izplatība, %',
    align: 'right',
    headerAlign: 'right'
  }
];

export const renderZemesLietojumsTable = (dataObj) => {
  let detailData = dataObj.zemes_lietojums_detalizeti;

  if (typeof detailData === 'string') {
    try {
      detailData = JSON.parse(detailData);
    } catch (e) {
      return '-';
    }
  }

  if (!detailData || !Array.isArray(detailData) || detailData.length === 0) {
    return '-';
  }

  const tableData = detailData.map((item, idx) => ({...item, _uniqueKey: `zl-${idx}`}));

  return (
    <div style={{marginTop: '10px'}}>
      <BootstrapTable
        keyField="_uniqueKey"
        data={tableData}
        columns={zemesLietojumsColumns}
        bootstrap4
        striped
        hover
        condensed
        classes="w-auto"
      />
    </div>
  );
};

const getFormFieldCfgs = ({kodif}) => {
  return [
    {
        ...getKlasifikatorsFieldCfg(kodif, 'dzeramaUdensSatecesBaseiniUdensNesejslanaTips'),
        name: 'nesejslana_tips',
        renderer: getFormatterForKodif(kodif.dzeramaUdensSatecesBaseiniUdensNesejslanaTips)
    }, {
        name: 'nesejslana_horizonta_indekss',
        type: 'autocomplete',
        autocompleteCfg: {
            initialOptionsViewName: 'urbumi_atradnes_horizonti_search',
            extraFilterParams: {},
            labelFieldName: 'nesejslana_horizonta_indekss'
        },
        overridePropsFunc: (props) => {
            const { currentValues } = props
            const atradnesId = currentValues.urbumi_atradnes_id
            if (!atradnesId) {
                return {
                    ...props,
                    editable: false
                }
            }
            return {
                ...props,
                autocompleteCfg: {
                    ...props.autocompleteCfg,
                    extraFilterParams: { ua_id: atradnesId }
                }
            }
        },
        renderer: (fieldValue) => fieldValue
    }, {
        ...getKlasifikatorsFieldCfg(kodif, 'dzeramaUdensSatecesBaseiniAizsargatiba'),
        name: 'aizsargatiba',
        renderer: getFormatterForKodif(kodif.dzeramaUdensSatecesBaseiniAizsargatiba),
        editable: true
    }, {
        ...getKlasifikatorsFieldCfg(kodif, 'dzeramaUdensSatecesBaseiniIezuTips'),
        name: 'iezu_tips',
        renderer: getFormatterForKodif(kodif.dzeramaUdensSatecesBaseiniIezuTips)
    }, {
        name: 'karsta_apgabali',
        label: 'Karsta apgabalu izplatība',
        editable: false
    }, {
        name: 'nitratjutiga_ter',
        label: 'Nitrātu jūtīgās teritorijas',
        editable: false
    }, {
        name: 'notece',
        editable: true
    }
  ]
}

const getFormFieldCfgsParams = ({kodif}) => {
  return [
    {
        name: 'filtracijas_koef',
        type: 'number',
        renderer: getNumberFormatter(),
        editable: true
    }, {
        name: 'gradients',
        type: 'number',
        renderer: getNumberFormatter(),
        editable: true
    }, {
        name: 'porainiba',
        type: 'number',
        renderer: getNumberFormatter(),
        editable: true
    }, {
        name: 'biezums',
        type: 'number',
        renderer: getNumberFormatter(),
        editable: true
    }, {
        name: 'plusmas_virziens',
        editable: true
    }, {
        name: 'vispariga_piezimes',
        label: 'Piezīmes',
        type: 'textarea',
        editable: true
    }
  ]
}

class BaseinsVisparigaisRaksturojums extends Component {

    render() {

        const {visparigaInfo, zemesLietojums, kodif, hasGeometry, isArhivets} = this.props

        const {selectedItem, editable, submiting} = visparigaInfo

        if (!selectedItem) {
            return (<Loading/>)
        }

        if (!hasGeometry) {
            return <NavGeometrijaBridinajums title="Vispārīgais raksturojums" />;
        }

        if(!this.formFieldCfgs){
            this.formFieldCfgs = getFormFieldCfgs({
                kodif: kodif
            })
        }

        if (!this.formFieldCfgsParams) {
            this.formFieldCfgsParams = getFormFieldCfgsParams({kodif: kodif})
        }

        if (!this.formFieldCfgsAll) {
            this.formFieldCfgsAll = [...this.formFieldCfgs, ...this.formFieldCfgsParams]
        }

        const paramsDataObj = zemesLietojums.selectedItem
            ? { ...selectedItem, ...zemesLietojums.selectedItem }
            : selectedItem

        return <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', overflowX: 'hidden' }}>
            {editable ? <>
                <Form
                    editable={editable}
                    submiting={submiting}
                    dataObj={paramsDataObj}
                    formFieldCfgs={this.formFieldCfgsAll}
                    metadataFormCfg="dzerama_udens_sateces_baseins_vispariga_info_view"
                    onSubmit={this.props.saveAct}
                    onReset={this.props.stopEditAct}
                    onStartEdit={this.props.startEditAct}
                    tiesibasLabot="SATECES_BASEINI_LABOT"
                />
            </> : <>
                {!isArhivets && this.props.user.tiesibas.includes('SATECES_BASEINI_LABOT') &&
                    <div className="actionButtons">
                        <Button color="primary" onClick={this.props.startEditAct}><i className="fa fa-pencil"></i>&nbsp;&nbsp;Labot</Button>
                    </div>
                }
                <h3>Hidroģeoloģiskais raksturojums</h3>
                <Form
                    editable={editable}
                    submiting={submiting}
                    dataObj={selectedItem}
                    formFieldCfgs={this.formFieldCfgs}
                    metadataFormCfg="dzerama_udens_sateces_baseins_vispariga_info_view"
                />

                <h3>Sateces baseina noteikšanai izmantotie parametri</h3>
                <Form
                    editable={editable}
                    submiting={submiting}
                    dataObj={paramsDataObj}
                    formFieldCfgs={this.formFieldCfgsParams}
                    metadataFormCfg="dzerama_udens_sateces_baseins_vispariga_info_view"
                />
            </>}

            <h3>Zemes lietošanas veids</h3>
            {renderZemesLietojumsTable(paramsDataObj)}

            <h3>Īpaši aizsargājamās dabas teritorijas</h3>
            {(!paramsDataObj.dabas_ter || paramsDataObj.dabas_ter === '-')
              ? <p>Sateces baseinā nav īpaši aizsargājamo dabas teritoriju.</p>
              : <ul>{paramsDataObj.dabas_ter.split('; ').map((t, i) => <li key={i}>{t}</li>)}</ul>
            }
        </div>
    }
}

const mapStateToProps = ({dzeramaUdensSatecesBaseins, dzeramaUdensSatecesBaseinsVisparigaInfo, dzeramaUdensSatecesBaseinsZemesLietojums, kodif, user}) => ({
    visparigaInfo: dzeramaUdensSatecesBaseinsVisparigaInfo,
    zemesLietojums: dzeramaUdensSatecesBaseinsZemesLietojums,
    isArhivets: !!(dzeramaUdensSatecesBaseins && dzeramaUdensSatecesBaseins.selectedItem && dzeramaUdensSatecesBaseins.selectedItem.ir_arhivets),
    kodif,
    user
})

const DzeramaUdensSatecesBaseinsVisparigaisRaksturojums = connect(mapStateToProps, {...dzeramaUdensSatecesBaseinsVisparigaInfoActions})(BaseinsVisparigaisRaksturojums)
export default DzeramaUdensSatecesBaseinsVisparigaisRaksturojums
